export default __webpack_public_path__ + "assets/images/image-forge.8524720d.png";